export default __webpack_public_path__ + "fonts/4b2b6f71a45acdcd30cd510e70e589883470f3dd398da9843a793d7839e6824c.ttf";